import '../ui-anchor/ui-anchor.lt';
import '../ui-annotation/ui-annotation.lt';
import '../ui-assets/ui-assets.lt';
import '../ui-autocomplete/ui-autocomplete.lt';
import '../ui-breadcrumbs/ui-breadcrumbs.lt';
import '../ui-button/ui-button.lt';
import '../ui-calendar/ui-calendar.lt';
import '../ui-chip/ui-chip.lt';
import '../ui-comparison-cards/ui-comparison-cards.lt';
import '../ui-countdown/ui-countdown.lt';
import '../ui-curtain/ui-curtain.lt';
import '../ui-datepicker/ui-datepicker.lt';
import '../ui-daterange/ui-daterange.lt';
import '../ui-dialogbubble/ui-dialogbubble.lt';
import '../ui-dropdown/ui-dropdown.lt';
import '../ui-feedback/ui-feedback.lt';
import '../ui-field/ui-field.lt';
import '../ui-footer/ui-footer.lt';
import '../ui-form/ui-form.lt';
import '../ui-message/ui-message.lt';
import '../ui-modal/ui-modal.lt';
import '../ui-monthpicker/ui-monthpicker.lt';
import '../ui-nav/ui-nav.lt';
import '../ui-navitem/ui-navitem.lt';
import '../ui-navlist/ui-navlist.lt';
import '../ui-navtoggle/ui-navtoggle.lt';
import '../ui-offer/ui-offer.lt';
import '../ui-salesribbon/ui-salesribbon.lt';
import '../ui-pagination/ui-pagination.lt';
import '../ui-phonefield/ui-phonefield.lt';
import '../ui-searchinput/ui-searchinput.lt';
import '../ui-signing/ui-signing.lt';
import '../ui-skip-to-content/ui-skip-to-content.lt';
import '../ui-slider/ui-slider.lt';
import '../ui-slides/ui-slides.lt';
import '../ui-stepper/ui-stepper.lt';
import '../ui-table-cloneable/ui-table-cloneable.lt';
import '../ui-table-expandable/ui-table-expandable.lt';
import '../ui-table-sortable/ui-table-sortable.lt';
import '../ui-tabs/ui-tabs.lt';
import '../ui-textcounter/ui-textcounter.lt';
import '../ui-timerange/ui-timerange.lt';
import '../ui-tooltip/ui-tooltip.lt';
import '../ui-upload-item/ui-upload-item.lt';
import '../ui-upload/ui-upload.lt';
import '../ui-video/ui-video.lt';
import '../ui-wizard/ui-wizard.lt';
import '../ui-asset/ui-asset.lt';
import '../ui-slideview/ui-slideview.lt';
import '../ui-rating/ui-rating.lt';
import { Labels } from '../../shared-components/global/labels';
import { Language } from '../../shared-components/global/enums';

Labels.LANGUAGE = Language.Lithuanian;

window.UI = { ...window.UI, Labels };
